import { render } from "./educationalOfflineInfo.vue?vue&type=template&id=52859f99&scoped=true"
import script from "./educationalOfflineInfo.vue?vue&type=script&lang=js"
export * from "./educationalOfflineInfo.vue?vue&type=script&lang=js"

import "./educationalOfflineInfo.vue?vue&type=style&index=0&id=52859f99&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\BmMuseumAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52859f99"]])

export default __exports__